<template>
  <div v-if="props.resourceData" class="resource-charge-container">
    <div class="resource-group-itemInfo">
      <!-- 左侧资源图标有多种方式 -->
      <div
        class="resource-header-left resource-charge-left"
        @click="() => handleDetail(props.resourceData?.detail)"
      >
        <img
          v-if="!props.resourceData.list_info.online_icon_url"
          :src="ImgData[props.resourceData.list_info.pin_type]"
          alt="nio"
        />
        <div
          v-else
          class="resource_self_icon"
          :style="{
            background:
              props.resourceData.list_info && props.resourceData.list_info.pin_type === 'nio_ps'
                ? '#1C7795'
                : '#00BEBE',
          }"
        >
          <img
            :src="props.resourceData.list_info.online_icon_url"
            class="active_self_icon"
            alt="nio"
          />
        </div>
        <img
          v-if="props.resourceData.list_info && props.resourceData.list_info.activity_icon_url"
          :src="props.resourceData.list_info.activity_icon_url"
          class="active_img"
          alt="nio"
        />
      </div>
      <!-- 右侧 数据 标题 时间  -->
      <div
        class="resource-content"
        v-if="props.resourceData?.module !== 'text_line'"
        @click="() => handleDetail(props.resourceData?.detail)"
      >
        <div class="resource-title-group">
          <h2 class="title-text">
            {{ props.resourceData?.detail ? props.resourceData?.detail.name : '' }}
          </h2>
          <div class="title-right">
            <!--  定位距离 -->
            <p
              class="resource-location"
              v-if="props.resourceData?.detail?.distance_desc"
              @click.stop="() => handleLocation(props.resourceData?.detail)"
            >
              <img
                src="https://cdn-fx.nio.com/fx/h5pages-nio/XkU6CgqvLeqvB3lWZL5bn/iconNavigation.svg"
                alt="nio"
              />
              <span>{{
                props.resourceData?.detail ? props.resourceData?.detail.distance_desc : ''
              }}</span>
            </p>
          </div>
        </div>



        <!-- tag -->
        <div
          class="resource-header-tag"
          v-if="props.resourceData?.list_info && props.resourceData?.list_info.tags"
        >
          <div
            class="resource-header-tag-item"
            v-for="(it, index) in props.resourceData?.list_info.tags"
            :key="index"
            :style="{ color: it.font_color, background: it.background_color }"
          >
            <img v-if="it.icon" class="tags_icon" :src="it.icon" alt="nio" />
            {{ it.text }}</div
          >
          <p
            class="resource-group-project"
            v-if="props.resourceData?.list_info && props.resourceData?.list_info.hints"
          >
            <span
              v-for="(it, index) in props.resourceData?.list_info.hints"
              :style="{ color: it.font_color }"
              :key="index"
              >{{ it.text }}</span
            >
          </p>
        </div>
        <!-- 资源信息 -->
        <div
          class="resource-charge-memo-info"
          v-if="props.resourceData?.list_info && props.resourceData?.list_info.tips"
        >
          <div v-for="(it, index) in props.resourceData?.list_info.tips" :key="index">
            <img v-if="it.icon" class="tags_icon" :src="it.icon" alt="nio" />
            <p v-html="getMark(it)"></p>
          </div>
        </div>

        <div
          class="price_group"
          v-if="props.resourceData?.list_info && props.resourceData?.list_info.price"
          v-html="getPrice(props.resourceData?.list_info.price)"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import openMap from './utils/index';
import { nioJsBridge } from '@nio-wad/universal-bridge-h5';


const props = defineProps<{
  resourceData?: {
    detail: {
      distance_desc: string;
      id: string;
      location: string; // longitude,latitude
      name: string;
      sub_type: string;
    };
    is_recommend?: boolean;
    list_info: {
      activity_icon_url?: string;
      price: any;
      hints: {
        font_color: string;
        text: string;
      }[];
      online_icon_url: string;
      pin_type:
        | 'nio_cs'
        | 'public_cs'
        | 'ps'
        | 'ps_clone'
        | 'private_cs'
        | 'nio_ps';
      tags: {
        background_color: string;
        font_color: string;
        icon?: string;
        text: string;
        type: 'recommend_reason' | 'negative' | 'positive';
      }[];
      tips: {
        icon?: string;
        normal_range: string[];
        super_range: string[];
        text: string;
      }[];
      title: string;
    };
    module?: string;
  };
}>();
const emit = defineEmits<{
  (e: 'handleGoDetail', location: string, name: string, id: string, sub_type: string, url: string): void;
  (e: 'handleNavigate', location: string, name: string, id: string, sub_type: string): void;
}>();

const ImgData = {
  nio_cs: 'https://cdn-fx.nio.com/fx/h5pages-nio/__cdn__/nio_scdc.png',
  public_cs: 'https://cdn-fx.nio.com/fx/h5pages-nio/__cdn__/nio_csac.png',
  ps: 'https://cdn-fx.nio.com/fx/pe-h5pages-fe/__cdn__/huandianp.png',
  ps_clone: 'https://cdn-fx.nio.com/fx/pe-h5pages-fe/__cdn__/huandianp.png',
  nio_ps_clone: 'https://cdn-fx.nio.com/fx/pe-h5pages-fe/__cdn__/huandianp.png',
  private_cs: 'https://cdn-fx.nio.com/fx/pe-h5pages-fe/__cdn__/jiayongp.png',
  nio_ps: 'https://cdn-fx.nio.com/fx/pe-h5pages-fe/__cdn__/huandianp.png',
  cs_ac: 'https://cdn-fx.nio.com/fx/h5pages-nio/__cdn__/nio_csac.png',
  cs_dc: 'https://cdn-fx.nio.com/fx/h5pages-nio/__cdn__/nio_scdc.png',
};

const handleDetail = (item: any) => {
  const url = `nio://service/charge_map?scene=resource&id=${item.id}&sub_type=${item.sub_type}`;
  emit('handleGoDetail', item.location, item.name, item.id, item.sub_type, url);
  nioJsBridge.openURL({
    data: {
      url: url,
    },
  });
};

const handleLocation = (item: any) => {
  const [lng, lat] = item.location ? item.location.split(',') : ['', ''];
  emit('handleNavigate', item.location, item.name, item.id, item.sub_type);
  openMap(String(lat), String(lng), item.name, item.id, item.sub_type);
};

const getMark = (item) => {
  if (item.normal_range) {
    const data = item.text.split('');
    item.normal_range.forEach((it, index: number) => {
      const [start, end] = it.split(',');
      const startNum = index * 2;
      const endNum = index * 2 + 1;
      data.splice(Number(start) + startNum, 0, '<span>');
      data.splice(Number(end) + Number(start) + endNum, 0, '</span>');
    });
    return data.join('');
  }
  return item.text;
};

const getPrice = (item: any) => {
  if (item.delete_range || item.super_range) {
    const data = item.text.split('');
    let deleteNmu = 0;
    let superNum = 0;
    if (item.delete_range) {
      item.delete_range.forEach((it: any, index: number) => {
        const [start, end] = it.split(',');
        const startNum = deleteNmu * 2;
        const endNum = deleteNmu * 2 + 1;
        deleteNmu = deleteNmu + index + 1;
        data.splice(Number(start) + startNum, 0, '<span class="price_del">');
        data.splice(Number(end) + Number(start) + endNum, 0, '</span>');
      });
    }

    if (item.super_range) {
      item.super_range.forEach((it: any, index: number) => {
        const [start, end] = it.split(',');
        const startNum = superNum * 2;
        const endNum = superNum * 2 + 1;
        superNum = superNum + index + 1;
        data.splice(Number(start) + startNum, 0, '<span class="price_now">');
        data.splice(Number(end) + Number(start) + endNum, 0, '</span>');
      });
    }
    return data.join('');
  }
  return item.text;
};
</script>
<style lang="scss">
.resource-charge-container {
  font-size: 0;
  .resource-group-itemInfo {
    padding: 10px;
    background: #fff;
    display: flex;
  }
  .resource-charge-left {
    position: relative;
    .resource_self_icon {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: #0e999e;
      text-align: center;
    }
    .active_self_icon {
      width: 20px;
      margin: 2px;
      height: 20px;
      object-fit: contain;
    }
    .active_img {
      position: absolute;
      width: 24px;
      height: 24px;
      bottom: 0px;
      top: 0px;
      left: 0px;
      right: 0px;
      border-radius: inherit;
      z-index: 999;
    }
  }
  .resource-header-left {
    width: 24px;
    height: 24px;
    margin-right: 10px;
    vertical-align: top;
    display: inline-block;
    position: relative;
    img {
      width: 24px;
      height: 24px;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  .resource-content {
    position: relative;
    flex: 1;
    width: calc(100vw - 104px);
    vertical-align: top;
    display: inline-block;
    color: #686d82;
    font-family: PingFang SC;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;

    .resource-title-group {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      width: 100%;

      .title-text {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .title-right {
        display: flex;
        align-items: center;
        gap: 4px;
        flex-shrink: 0;
        font-size: 12px;
        margin-top: 2px;  // 添加一点顶部间距
      }
    }

    h2 {
      overflow: hidden;
      color: #090c1a;
      font-family: PingFang SC;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      margin-top: 0;
      margin-bottom: 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      line-clamp: 2;
      box-orient: vertical;
      padding-right: 48px;
      width: 100%;
    }
    .resource-location {
      // position: absolute;
      // top: 2px;
      // right: 0px;
      // text-align: right;
      img {
        width: 14px;
        height: 14px;
        vertical-align: sub;
      }
      span {
        margin-left: 2px;
        display: inline-block;
        color: #090c1a;
      }
    }
    p {
      margin-top: 0;
      margin-bottom: 0;
    }
    .resource-hader-memo {
      margin: 2px 0 4px;
    }
    .resource-vertical-middle {
      vertical-align: middle;
    }
    .resource-hader-score {
      color: #fab040;
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 18px;
    }
  }
  .resource-header-tag {
    margin-top: 6px;
    margin-bottom: 8px;
    padding-right: 100px;
    line-height: 1.5em;
    max-height: 1.5em;
    overflow: hidden;
    position: relative;
    .resource-header-tag-item {
      color: #686d82;
      font-family: PingFang SC;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 1.5em;
      display: inline-block;
      height: 1.5em;
      padding: 0px 6px;
      margin-right: 6px;
      margin-bottom: 6px;
      background: #f6f6f6;
    }
    .resource-group-project {
      position: absolute;
      right: 0px;
      top: 0px;
      width: 100px;
      white-space: nowrap; /* 保证文本不会换行 */
      overflow: hidden; /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
      text-align: right;
      span {
        font-size: 12px;
        margin-right: 0;
        padding: 0px;
        background: none;
      }
    }
    .tags_icon {
      width: 12px;
      vertical-align: sub;
      margin-right: 2px; // 添加右边距
    }
    .active {
      color: #fff;
      background: #0e999e;
    }
  }

  .resource-charge-memo-info {
    div {
      display: inline-block;
      margin-right: 4px;
      padding-right: 4px;
      position: relative;
      &:not(:last-child)::after {
        content: '';
        position: absolute;
        background: #ebecee;
        display: block;
        top: 4px;
        right: 0;
        width: 1px;
        height: 8px;
      }
      &:last-child {
        padding-right: 0;
        margin-right: 0;
      }
    }
    img {
      width: 10px;
      height: 10px;
      margin-right: 2px;
      vertical-align: 0px;
    }
    p {
      display: inline-block;
      padding-right: 5px;
      margin-right: 5px;
      height: 12px;
      color: #090c1a;
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      position: relative;
      span {
        color: #090c1a;
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
      &:not(:last-child)::after {
        content: '';
        position: absolute;
        background: #f0f1f2;
        display: block;
        top: 4px;
        right: 0;
        width: 1px;
        height: 8px;
      }
      &:last-child {
        padding-right: 0;
        margin-right: 0;
      }
    }
  }
  .price_group {
    //   position: absolute;
    //   right: 0px;
    //   bottom: 0;
    margin-top: 6px;
    font-family: PingFang SC;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    color: #0e999e;
    line-height: 18px;
  }
  .price_del {
    margin-left: 4px;
    color: #9b9da6;
    font-family: PingFang SC;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    text-decoration: line-through;
  }
  .price_now {
    color: #0e999e;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
  }
  .resource-commodity-group-more {
    text-align: center;
  }
  .resource-commodity-more {
    text-align: center;
    width: 120px;
    display: inline-block;
    color: #686d82;
    font-family: PingFang SC;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    img {
      vertical-align: middle;
    }
  }
}
</style>
